import { client } from "./client";
import type {
  LoginRequest,
  RegisterRequest,
  GoogleLoginRequest,
  AuthResponse,
  AuthTokens,
  ForgotPasswordRequest,
  ResetPasswordRequest,
  ChangePasswordRequest,
  UserProfile,
} from "@/types/api/auth.types";

export const authApi = {
  login: (data: LoginRequest) =>
    client.post<unknown, AuthResponse>("/v1/auth/login", data),

  register: (data: RegisterRequest) =>
    client.post<unknown, AuthResponse>("/v1/auth/register", data),

  googleLogin: (data: GoogleLoginRequest) =>
    client.post<unknown, AuthResponse>("/v1/auth/google", data),

  refresh: (refreshToken: string) =>
    client.post<unknown, AuthTokens>("/v1/auth/refresh", {
      refresh_token: refreshToken,
    }),

  logout: () => client.post("/v1/auth/logout"),

  logoutAll: () => client.post("/v1/auth/logout-all"),

  me: () => client.get<unknown, UserProfile>("/v1/auth/me"),

  forgotPassword: (data: ForgotPasswordRequest) =>
    client.post("/v1/auth/forgot-password", data),

  resetPassword: (data: ResetPasswordRequest) =>
    client.post("/v1/auth/reset-password", data),

  changePassword: (data: ChangePasswordRequest) =>
    client.post("/v1/auth/change-password", data),
};
